const GIFT_VARIANT_ID = 58119272006013;
const GIFT_THRESHOLD = 6000;
const MANUALLY_REMOVED_KEY = 'gift_manually_removed';

const getCart = () => fetch('/cart.js').then(r => r.json());

const addGift = () => {
  return fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: GIFT_VARIANT_ID, quantity: 1 })
  }).then(r => r.json());
};

const removeGift = async () => {
  const cart = await getCart();
  const giftItem = cart.items.find(item => item.variant_id === GIFT_VARIANT_ID);
  if (!giftItem) return;
  
  return fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: giftItem.key, quantity: 0 })
  }).then(r => r.json());
};

const handleGiftPromotion = async () => {
  const cart = await getCart();
  const total = cart.total_price;
  const hasGift = cart.items.some(item => item.variant_id === GIFT_VARIANT_ID);
  const manuallyRemoved = sessionStorage.getItem(MANUALLY_REMOVED_KEY) === 'true';

  if (total >= GIFT_THRESHOLD) {
    if (!hasGift && !manuallyRemoved) {
      await addGift();
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    }
  } else {
    sessionStorage.removeItem(MANUALLY_REMOVED_KEY);
    if (hasGift) {
      await removeGift();
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    }
  }
};

let previousHadGift = false;

if (typeof theme !== 'undefined' && theme.pubsub) {
  theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, async (event) => {
    const cart = await getCart();
    const hasGift = cart.items.some(item => item.variant_id === GIFT_VARIANT_ID);
    const total = cart.total_price;

    // Si antes tenía regalo, ahora no tiene, y sigue por encima de 60€
    // significa que lo quitó manualmente
    if (previousHadGift && !hasGift && total >= GIFT_THRESHOLD) {
      sessionStorage.setItem(MANUALLY_REMOVED_KEY, 'true');
    }

    previousHadGift = hasGift;
    await handleGiftPromotion();
  });
  
}

// for pagina /cart
if (window.location.pathname === '/cart') {
  const initCartObserver = () => {
    const cartItemsEl = document.querySelector('cart-items');
    if (cartItemsEl) {
      const observer = new MutationObserver(() => handleGiftPromotion());
      observer.observe(cartItemsEl, { childList: true, subtree: true });
      handleGiftPromotion();
    } else {
      setTimeout(initCartObserver, 500);
    }
  };
  initCartObserver();
}